export default Object.freeze({
  RpVisitSummary: 4,
});
